import _ from 'lodash';

/**
 * Automatically imports all the modules and exports as a single module object
 */
const requireModule = require.context('.', false, /\.js$/);
const modules = {};

requireModule.keys().forEach(filename => {
  if (filename === './index.js')
    return;

  // create the module name from fileName
  // remove the .js extension and change to camelCase
  const moduleName = _.camelCase(
    filename.replace(/(\.\/|\.js)/g, '')
  );

  modules[moduleName] = requireModule(filename).default || requireModule(filename);
});

export default modules;
